// Manager exceptions list (approved HTML component: manager-exceptions).
import type { ReactNode } from 'react';
import type { ExceptionRow } from '../mockData.js';

export interface ManagerExceptionsProps {
  rows: ExceptionRow[];
  onOpenException?: (row: ExceptionRow) => void;
}

export function ManagerExceptions({
  rows,
  onOpenException,
}: ManagerExceptionsProps): ReactNode {
  return (
    <section className="n-card" data-component="manager-exceptions">
      <div className="n-head">
        <h2>Needs your attention</h2>
        <small>{rows.length} example{rows.length === 1 ? '' : 's'}</small>
      </div>
      <div className="n-body">
        <ul className="n-list">
          {rows.map(row => (
            <li key={row.id}>
              <strong>{row.title}</strong>
              <p>{row.body}</p>
              <button
                className="n-link"
                type="button"
                data-exception={row.kind}
                onClick={() => onOpenException?.(row)}
              >
                {row.cta}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
